<script>
    /*
    	ReferralHeader.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let section;
    export let isExpanded;
    export let setExpanded;

    onMount(() => {
    })

    const _onCircleClick = () => {
        console.log(section);
        setExpanded(section.sectionId)
    }

</script>

<style>
    .referral-header {
        width: 100%;
        margin-bottom: 5px;
        justify-content: flex-start;
        /* border: 1px solid green; */
    }

    .referral-header .circle-wrapper {
        width: 8%;
    }

    .referral-header .circle {
        color: var(--tcui-primary);
        background-color: none;
        border: 2px solid var(--tcui-periwinkle);
        border-radius: 50%;
    }

    .referral-header .circle.expanded {
        width: 16px;
        height: 16px;
        background-color: var(--tcui-aqua-light);
    }

    .referral-header .circle.collapsed {
        width: 10px;
        height: 10px;
    }

    .referral-header .header-bar {
        width: 92%;
        padding: 15px 2%;
        font-size: 18px;
        border-radius: 15px;
    }

    .referral-header .header-bar.expanded {
        color: var(--tcui-primary);
        background-color: none;
    }

    .referral-header .header-bar.collapsed {
        color: var(--tcui-periwinkle);
        background-color: var(--tcui-aqua-light);
    }




    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<!-- TODO: read in the IPA data and iterate questions -->
<!-- TODO: make ReferralQuestion components -->

{#if isExpanded}
    <div class="referral-header flex-row">
        <div class="circle-wrapper flex-center">
            <div class="circle expanded"></div>
        </div>
        <div class="header-bar expanded">
            {section.sectionlabel}
        </div>
    </div>
{:else}
    <div class="referral-header flex-row">
        <div class="circle-wrapper flex-center">
            <div class="circle collapsed" on:click={_onCircleClick}></div>
        </div>
        <div class="header-bar collapsed">
            {section.sectionlabel}
        </div>
    </div>
{/if}
